import React, { useState, useEffect } from "react";
import { iconDemo } from "utils/constants";
import { compose } from "redux";
import { useNavigate, useLocation } from "react-router-dom";
import enhancer from "./enhancer/VerifyOTPFormEnhancer";
import axios from "axios";
import AppModal from "components/ui/AppModal/AppModal";
// import loginBackVideo from "assets/images/VídeoBackGround.mp4";
import styles from "./auth.module.css";

const VerifyOTP = props => {
  const navigate = useNavigate();
  const location = useLocation();
  const { values, isValid, setFieldValue } = props;
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [autoVerifyAttempted, setAutoVerifyAttempted] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    variant: "custom",
    title: "",
    message: "",
    confirmText: "OK"
  });
  const [afterConfirmRoute, setAfterConfirmRoute] = useState(null);

  const closeFeedbackModal = () =>
    setFeedbackModal(prev => ({ ...prev, open: false }));

  const handleConfirm = () => {
    closeFeedbackModal();
    if (afterConfirmRoute) {
      const route = afterConfirmRoute;
      setAfterConfirmRoute(null);
      navigate(route);
    }
  };

  const verifyCredentials = async (email, otp_code) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/verify-otp`,
        { email, otp_code }
      );
      if (response.status === 201) {
        setAfterConfirmRoute("/login");
        setFeedbackModal({
          open: true,
          variant: "success",
          title: "Verificação Bem-sucedida!",
          message: "Conta verificada com sucesso."
        });
      } else {
        setAfterConfirmRoute(null);
        setFeedbackModal({
          open: true,
          variant: "error",
          title: "Erro!",
          message: "Erro desconhecido ao verificar o código."
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setAfterConfirmRoute(null);
        setFeedbackModal({
          open: true,
          variant: "error",
          title: "Erro!",
          message: error.response.data.detail || "Código inválido."
        });
      } else {
        setAfterConfirmRoute(null);
        setFeedbackModal({
          open: true,
          variant: "error",
          title: "Erro de Comunicação!",
          message:
            "Não foi possível conectar ao servidor. Verifique sua conexão ou tente mais tarde."
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const search = location?.search || "";
    const query = new URLSearchParams(search);
    const emailFromUrl = query.get("email");
    const codeFromUrl = query.get("code");
    if (emailFromUrl && codeFromUrl && !autoVerifyAttempted) {
      setAutoVerifyAttempted(true);
      setFieldValue("email", emailFromUrl, false);
      setFieldValue("otp_code", codeFromUrl, false);
      verifyCredentials(emailFromUrl, codeFromUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.search, autoVerifyAttempted, setFieldValue]);

  const handleVerifyOTP = async e => {
    e.preventDefault();
    if (isValid) {
      verifyCredentials(values.email, values.otp_code);
    }
  };

  const handleResendOTP = async () => {
    if (!values.email) {
      setAfterConfirmRoute(null);
      setFeedbackModal({
        open: true,
        variant: "error",
        title: "Erro!",
        message: "Por favor, insira o seu e-mail para reenviar o código."
      });
      return;
    }
    setResendLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/resend-otp`,
        { email: values.email }
      );
      if (response.status === 200) {
        setAfterConfirmRoute(null);
        setFeedbackModal({
          open: true,
          variant: "success",
          title: "Código Reenviado!",
          message: "O código foi reenviado para o seu e-mail."
        });
      } else {
        setAfterConfirmRoute(null);
        setFeedbackModal({
          open: true,
          variant: "error",
          title: "Erro!",
          message: "Erro desconhecido ao reenviar o código."
        });
      }
    } catch (error) {
      setAfterConfirmRoute(null);
      setFeedbackModal({
        open: true,
        variant: "error",
        title: "Erro!",
        message:
          error.response?.data?.detail || "Erro desconhecido ao reenviar o código."
      });
    } finally {
      setResendLoading(false);
    }
  };

  const { handleChange, handleBlur, errors, touched, submitCount } = props;

  const Error = ({ field, class: cls }) => {
    if ((errors[field] && touched[field]) || submitCount > 0) {
      return <span className={cls || styles.errorMsg}>{errors[field]}</span>;
    }
    return <span />;
  };

  return (
    <div className={styles.root}>
{/* <video autoPlay muted loop className={styles.videoBg}>
        <source src={loginBackVideo} type="video/mp4" />
      </video> */}
      <div className={styles.overlay} />

      <div className={styles.card}>
        <div className={styles.logoWrap}>
          <img src={iconDemo} alt="Vertex4D" className={styles.logo} />
        </div>
        <h1 className={styles.title}>Verificar Conta</h1>
        <p className={styles.subtitle}>
          Insira o código enviado para o seu e-mail para ativar a conta.
        </p>

        <form onSubmit={handleVerifyOTP} noValidate>
          <div className={styles.formGroup}>
            <label className={styles.label}>Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className={styles.input}
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="seu@email.com"
              required
            />
            <Error field="email" />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Código de Verificação</label>
            <input
              type="text"
              id="otp_code"
              name="otp_code"
              className={styles.inputCode}
              value={values.otp_code}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="000000"
              required
            />
            <Error field="otp_code" />
          </div>

          <button
            type="submit"
            className={`${styles.btn} ${styles.btnPrimary}`}
            disabled={loading}
          >
            {loading ? <><div className={styles.spinner} /> Verificando...</> : "Verificar"}
          </button>
        </form>

        <p className={styles.linkRow}>
          Não recebeu o código?{" "}
          <button className={styles.link} onClick={handleResendOTP} disabled={resendLoading}>
            {resendLoading ? <><div className={styles.spinner} style={{ width: 12, height: 12, borderWidth: 1.5 }} /></> : "Reenviar"}
          </button>
        </p>
        <p className={styles.linkRow}>
          Já verificou?{" "}
          <button className={styles.link} onClick={() => navigate("/login")}>
            Acessar
          </button>
        </p>
      </div>

      <AppModal
        isOpen={feedbackModal.open}
        onClose={closeFeedbackModal}
        allowOutsideClick={true}
        variant={feedbackModal.variant}
        title={feedbackModal.title}
        message={feedbackModal.message}
        confirmText={feedbackModal.confirmText}
        cancelText={null}
        onConfirm={handleConfirm}
        onCancel={closeFeedbackModal}
      />
    </div>
  );
};

export default compose(enhancer)(VerifyOTP);
